var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_shared-key.js
// module id = 175
// module chunks = 16